module.exports = __webpack_public_path__ + "static/img/chengguo2@2x.d4248959.png";